import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Element, scroller, Link as ScrollLink } from 'react-scroll';
import classNames from 'classnames';
import AppStoreButton from 'common/components/appStoreButton';
import GooglePlayButton from 'common/components/googlePlayButton';
import ExanteModal from 'common/components/exanteModal';
import ModalContainer from 'common/components/modalContainer';
import Contact from 'landing/containers/contact';
import CircleSpinner from 'common/components/circleSpinner';
import ReactPlayer from 'react-player';
import AuthenticationForbidden from 'permissions/components/authenticationForbidden';
import Slide from 'react-reveal/Slide';
import isMobileViewActive from 'common/utils/viewUtils';
import { disableScroll } from 'common/utils/disableScroll';
import shortid from 'shortid';
import './index.scss';
import LandingAuthButtons from '../landingAuthButtons';

class LandingView extends Component {
  constructor() {
    super();
    this.state = {
      isExanteModalDisplayed: false,
      isContactmodalVisible: false,
      contactModalMessage: '',
    };
  }

  componentDidMount() {
    scroller.scrollTo(this.props.routerState.target, {
      smooth: this.props.routerState.smooth,
      offset: this.props.routerState.offset,
      duration: this.props.routerState.duration,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    scroller.scrollTo(nextProps.routerState.target, {
      smooth: nextProps.routerState.smooth,
      offset: nextProps.routerState.offset,
      duration: nextProps.routerState.duration,
    });
  }

  toggleExanteModal = () => {
    disableScroll(!this.state.isExanteModalDisplayed);
    this.setState((prevState) => ({
      isExanteModalDisplayed: !prevState.isExanteModalDisplayed,
    }));
  };

  contactModalVisibleChange = (status) => {
    this.setState(
      {
        isContactmodalVisible: status.visible,
        contactModalMessage: status.message,
      },
      () => disableScroll(this.state.isContactmodalVisible),
    );
  };

  render() {
    const { landingData, theme } = this.props;
    return (
      <>
        {landingData ? (
          <div className="main-landing">
            <Element name="top">
              <section className="landing-hero">
                <Container>
                  <Row className="landing-hero__bs-row">
                    <Col xs="12" md="12" className="landing-hero__bs-col">
                      <header className="landing-hero__header">
                        <Col xs="12" md="8">
                          <h1 className="landing-hero__heading">
                            {landingData.heroTitle}
                          </h1>
                          <h2 className="landing-hero__sub-heading">
                            {landingData.heroSubTitle}
                          </h2>
                          <div
                            className="landing-hero__copy"
                            dangerouslySetInnerHTML={{
                              __html: landingData.heroText,
                            }}
                          />
                        </Col>
                        <LandingAuthButtons />
                      </header>
                      <div>
                        <p className="landing-hero__cta">
                          Download our app today from any app store. Available
                          on smart phones and tablets.
                        </p>
                        <div className="landing-hero__app-buttons">
                          <AppStoreButton />
                          <GooglePlayButton />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </section>

              {landingData.bannerImage && (
                <section className="landing-banner">
                  <Slide bottom>
                    <Container>
                      <Row className="landing-banner__bs-row">
                        <Col xs="12" md="12" className="landing-banner__bs-col">
                          {landingData.bannerUrl ? (
                            <a
                              href={landingData.bannerUrl}
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              <img src={landingData.bannerImage} alt="" />
                            </a>
                          ) : (
                            <img src={landingData.bannerImage} alt="" />
                          )}
                        </Col>
                      </Row>
                    </Container>
                  </Slide>
                </section>
              )}

              <section
                className={classNames({
                  'landing-benefits': true,
                  'landing-benefits--top': !landingData.bannerImage,
                })}
              >
                <Slide bottom>
                  <Container>
                    <div className="landing-benefits__container">
                      <h2 className="landing-benefits__heading">
                        {landingData.benefitsTitle}
                      </h2>
                      <Row>
                        <Col xs="12" md="6">
                          <div className="landing-benefits__box landing-benefits__box--investor">
                            <p className="landing-benefits__sub-heading">
                              {landingData.benefitsSubTitle1}
                            </p>
                            <div className="landing-benefits__copy">
                              <ul className="landing-benefits__copy-list">
                                {landingData.benefitsList1.map((item) => (
                                  <li key={shortid.generate()}>{item}</li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </Col>
                        <Col xs="12" md="6">
                          <div className="landing-benefits__box landing-benefits__box--company">
                            <p className="landing-benefits__sub-heading">
                              {landingData.benefitsSubTitle2}
                            </p>
                            <div className="landing-benefits__copy">
                              <ul className="landing-benefits__copy-list">
                                {landingData.benefitsList2.map((item) => (
                                  <li key={shortid.generate()}>{item}</li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Container>
                </Slide>
              </section>
            </Element>
            <section className="landing-about">
              <Element name="about">
                <Container>
                  <Slide bottom>
                    <Row>
                      <Col xs="12" md="6">
                        <div className="landing-about__about-copy">
                          <h2 className="landing-about__heading">
                            {landingData.aboutTitle}
                          </h2>
                          <p className="landing-about__copy">
                            {landingData.aboutText}
                          </p>
                        </div>
                      </Col>
                      <Col xs="12" md="6">
                        {landingData.aboutImage && (
                          <img src={landingData.aboutImage} alt="" />
                        )}
                        {landingData.aboutVideo && !landingData.aboutImage && (
                          <div className="landing-about__video-container">
                            <ReactPlayer
                              url={landingData.aboutVideo}
                              height="100%"
                              width="100%"
                              config={{
                                youtube: {
                                  playerVars: {
                                    showinfo: 1,
                                    controls: 2,
                                  },
                                },
                                file: {
                                  attributes: {
                                    controls: true,
                                    controlsList: 'nodownload',
                                  },
                                },
                              }}
                            />
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Slide>
                  <Slide bottom>
                    <Row>
                      <Col xs="12" md={{ size: 6, order: 2 }}>
                        <div className="landing-about__platform-copy">
                          <h2 className="landing-about__heading">
                            {landingData.platformTitle}
                          </h2>
                          <p className="landing-about__copy">
                            {landingData.platformText}
                          </p>
                        </div>
                      </Col>
                      <Col xs="12" md={{ size: 6, order: 1 }}>
                        {landingData.platformImage && (
                          <img src={landingData.platformImage} alt="" />
                        )}
                        {landingData.platformVideo &&
                          !landingData.platformImage && (
                            <div className="landing-about__video-container">
                              <ReactPlayer
                                url={landingData.platformVideo}
                                height="100%"
                                width="100%"
                                config={{
                                  youtube: {
                                    playerVars: {
                                      showinfo: 1,
                                      controls: 2,
                                    },
                                  },
                                  file: {
                                    attributes: {
                                      controls: true,
                                      controlsList: 'nodownload',
                                    },
                                  },
                                }}
                              />
                            </div>
                          )}
                      </Col>
                    </Row>
                  </Slide>
                </Container>
              </Element>
            </section>
            <section className="landing-contact">
              <Element name="contact">
                {this.state.isContactmodalVisible && (
                  <ModalContainer className="contact-modal">
                    <div className="contact-modal-container">
                      <p className="contact-modal-message">
                        {this.state.contactModalMessage}
                      </p>
                      <Button
                        className="mr-4 contact-modal-button"
                        outline
                        color="primary"
                        onClick={() => {
                          this.setState({ isContactmodalVisible: false }, () =>
                            disableScroll(this.state.isContactmodalVisible),
                          );
                        }}
                      >
                        return
                      </Button>
                    </div>
                  </ModalContainer>
                )}
                <Container>
                  <Row>
                    <Col xs="12" md="6">
                      <Slide bottom>
                        <Row>
                          <Col>
                            <h2 className="landing-contact__heading">
                              {landingData.contactTitle}
                            </h2>
                            <p
                              className={`landing-contact__copy landing-contact__copy-${
                                theme === 'dark' && theme
                              }`}
                            >
                              {landingData.contactText}
                            </p>
                          </Col>
                        </Row>
                        <div className="landing-contact__form">
                          <Contact
                            contactModalVisibleChange={
                              this.contactModalVisibleChange
                            }
                          />
                        </div>
                      </Slide>
                    </Col>
                    <Col xs="12" md="6">
                      <Slide bottom>
                        <div className="landing-contact__support">
                          <h2 className="landing-contact__heading">
                            {landingData.supportTitle}
                          </h2>
                          <p
                            className={`landing-contact__copy landing-contact__copy-${
                              theme === 'dark' && theme
                            }`}
                          >
                            {landingData.supportText}
                          </p>
                          <img
                            className="landing-contact__image"
                            src={landingData.supportImage}
                            alt=""
                          />
                          <div className="landing-contact__contact">
                            <div>
                              <p className="landing-contact__copy landing-contact__name">
                                {landingData.supportName}
                              </p>
                              <p
                                className={`landing-contact__copy landing-contact__position landing-contact__copy-${
                                  theme === 'dark' && theme
                                }`}
                              >
                                {landingData.supportPosition}
                              </p>
                            </div>
                            <div>
                              <p className="landing-contact__copy landing-contact__email">
                                <a
                                  className="landing-contact__link"
                                  href="mailto:info@fintex.ltd"
                                >
                                  {landingData.supportEmail}
                                </a>
                              </p>
                              <p className="landing-contact__copy landing-contact__phone">
                                <a
                                  className="landing-contact__link"
                                  href="tel:+41444404344"
                                >
                                  {landingData.supportPhone}
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                      </Slide>
                    </Col>
                  </Row>
                </Container>
              </Element>
            </section>
            <section className="landing-offices">
              <Element name="offices">
                <Slide bottom>
                  <Container>
                    <h2 className="landing-offices__heading">
                      {landingData.officesTitle}
                    </h2>
                    <Row>
                      {landingData.offices.map((office) => (
                        <Col xs="12" md="4" key={shortid.generate()}>
                          <div className="landing-offices__item">
                            <p className="landing-offices__city">
                              {office.country}
                            </p>
                            {!office.soon && (
                              <>
                                <div className="landing-offices__contact">
                                  <p>{office.name}</p>
                                  <p>
                                    <a
                                      className="landing-contact__link"
                                      href="mailto:info@fintex.ltd"
                                    >
                                      {office.email}
                                    </a>
                                  </p>
                                  <p>
                                    <a
                                      className="landing-contact__link"
                                      href="tel:+41444404344"
                                    >
                                      {office.phone}
                                    </a>
                                  </p>
                                </div>
                                {office.address && (
                                  <div
                                    className={`landing-offices__address landing-offices__address-${
                                      theme === 'dark' && theme
                                    }`}
                                  >
                                    {office.address}
                                  </div>
                                )}
                              </>
                            )}
                            {office.soon && (
                              <p className="landing-offices__tba">
                                Coming soon!
                              </p>
                            )}
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Container>
                </Slide>
              </Element>
            </section>
            <section className="landing-corporate">
              <Element name="corporate">
                <Slide bottom>
                  <Container>
                    <div className="landing-corporate__header">
                      <h2 className="landing-corporate__heading">
                        {landingData.corporateTitle}
                      </h2>
                      <p className="landing-corporate__copy">
                        {landingData.corporateText1}
                      </p>
                      <p className="landing-corporate__copy">
                        {landingData.corporateText2}
                      </p>
                    </div>
                    <Row>
                      <Col xs="12" md="6">
                        <p className="landing-corporate__copy-offset landing-corporate__copy-offset--left">
                          {landingData.corporateText3}
                        </p>
                        <Slide left>
                          <div className="landing-corporate__box landing-corporate__box--left">
                            <p className="landing-corporate__box-copy">
                              “
                              {landingData.corporateQuote1}
                              ”
                            </p>
                          </div>
                        </Slide>
                      </Col>
                      <Col xs="12" md="6">
                        <Slide right>
                          <div className="landing-corporate__box landing-corporate__box--right">
                            <p className="landing-corporate__box-copy">
                              “
                              {landingData.corporateQuote2}
                              ”
                            </p>
                          </div>
                        </Slide>
                        <p className="landing-corporate__copy-offset landing-corporate__copy-offset--right">
                          {landingData.corporateText4}
                        </p>
                      </Col>
                    </Row>
                  </Container>
                </Slide>
              </Element>
            </section>
            {/*REMOVED EXANTE SECTION*/}
            {/*<section className="landing-summary">*/}
            {/*  <Slide bottom>*/}
            {/*    <Container>*/}
            {/*      <div className="landing-summary__content">*/}
            {/*        <h2 className="landing-summary__heading">*/}
            {/*          That&apos;s all, when it comes to us.*/}
            {/*        </h2>*/}
            {/*        <p className="landing-summary__sub-heading">*/}
            {/*          What&apos;s next?*/}
            {/*        </p>*/}
            {/*        <p className="landing-summary__copy">*/}
            {/*          Create an account or start investment using our*/}
            {/*          recommended Trading page Exante.*/}
            {/*        </p>*/}
            {/*        <div className="landing-summary__buttons">*/}
            {/*          <AuthenticationForbidden>*/}
            {/*            <LinkContainer*/}
            {/*              to={isMobileViewActive() ? '/login' : '/auth'}*/}
            {/*            >*/}
            {/*              <Button*/}
            {/*                color="primary"*/}
            {/*                className="landing-summary__auth-button"*/}
            {/*              >*/}
            {/*                Log in*/}
            {/*              </Button>*/}
            {/*            </LinkContainer>*/}
            {/*          </AuthenticationForbidden>*/}
            {/*          <Button*/}
            {/*            outline*/}
            {/*            color="primary"*/}
            {/*            onClick={this.toggleExanteModal}*/}
            {/*          >*/}
            {/*            Trading*/}
            {/*          </Button>*/}
            {/*        </div>*/}
            {/*      </div>*/}
            {/*    </Container>*/}
            {/*  </Slide>*/}
            {/*</section>*/}
            <ScrollLink
              to="top"
              className="main-landing__top-button"
              activeClass="main-landing__top-button--active"
              spy
              smooth
              offset={-200}
              duration={500}
            >
              Top
            </ScrollLink>

            {this.state.isExanteModalDisplayed && (
              <ExanteModal toggleExanteModal={this.toggleExanteModal} />
            )}
          </div>
        ) : (
          <div className="main-landing__load-container">
            <CircleSpinner color="white" />
          </div>
        )}
      </>
    );
  }
}

LandingView.defaultProps = {
  routerState: {
    target: '',
    smooth: null,
    offset: null,
    duration: null,
  },
  theme: 'light',
};

export default LandingView;
